import { getSalonAdminApiBaseUrl } from '../salon-admin/utils/apiConfig';

function apiBase() {
  return (getSalonAdminApiBaseUrl() || '').replace(/\/$/, '');
}

export async function saveKioskStoreLocation({ latitude, longitude, accuracy }) {
  const res = await fetch(`${apiBase()}/franchise-flow/store-location`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ latitude, longitude, accuracy }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.message || 'Failed to save store location');
  }
  return data;
}
